import { render, staticRenderFns } from "./MainProjectView.vue?vue&type=template&id=72b0d082&scoped=true&"
import script from "./MainProjectView.vue?vue&type=script&lang=ts&"
export * from "./MainProjectView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0d082",
  null
  
)

export default component.exports